<div class="projets-page"> <br><br><br>
  <!-- En-tête du projet sélectionné -->

<section class="py-5 text-white"
  style="background: linear-gradient(135deg, #2c3e50 0%, #1a1a2e 100%);">

  <!-- TITRE PRINCIPAL -->
  <div class="container">
  <div class="d-flex align-items-center justify-content-between mb-5">
  


  <!-- Titre centré -->
  <h1 class="text-white fw-bold m-0 text-center flex-grow-1">
    PROJETS D'INVESTISSEMENTS DE LA MAIRIE
  </h1>
  <!-- Bouton retour à gauche -->
  <button
    class="btn btn-outline-primary"
    (click)="goBack()">
    ← Retour
  </button>
  <!-- Espace vide pour garder le titre bien centré -->
  <div style="width: 95px;"></div>

</div>


    <!-- CONTENU EN DEUX COLONNES -->
    <div class="row align-items-center">

      <!-- COLONNE GAUCHE : TEXTE -->
      <div class="col-md-6 mb-4 mb-md-0">

       

        <h2 class="fw-semibold text-white mb-3">
          {{ projetDetailsIems.titre_projet  || '-'}}
        </h2>

        <p class="fs-5 lh-lg">
          {{ projetDetailsIems.description_projet|| '-' }}
        </p>

      </div>

      <!-- COLONNE DROITE : IMAGE -->
      <div class="col-md-6 text-center">
        <img
          class="img-fluid rounded shadow"
          [src]="projetDetailsIems.photo"
          (error)="onImageError($event)"
          [alt]="projetDetailsIems.titre_projet">
      </div>

    </div>
  </div>
</section>



  <!-- Liste des autres projets -->
  <section class="sites-section">
    <div class="container">

      <div class="section-header text-center mb-4">
        <h2>Autres projets {{ projects.length }} projet(s)</h2>
        <p></p>
      </div>

    <div class="sites-grid">

  <!-- SKELETON -->
  <ng-container *ngIf="loading; else content">
    <div class="site-card" *ngFor="let i of [1,2,3]">

      <div class="card-image">
        <p-skeleton width="100%" height="200px"></p-skeleton>
      </div>

      <div class="card-content">
        <p-skeleton width="70%" height="1.2rem"></p-skeleton>

        <p-skeleton width="100%" height="0.9rem" class="mt-2"></p-skeleton>
        <p-skeleton width="95%" height="0.9rem"></p-skeleton>
        <p-skeleton width="90%" height="0.9rem"></p-skeleton>

        <div class="card-footer text-center">
          <p-skeleton width="40%" height="0.9rem"></p-skeleton>
        </div>
      </div>

    </div>
  </ng-container>

  <!-- CONTENU RÉEL -->
  <ng-template #content>
    <div class="site-card" *ngFor="let projet of displayedProjects">

      <div class="card-image">
        <img
          [src]="projet.photo"
          (error)="onImageError($event)"
          [alt]="projet.titre_projet"
          loading="lazy"
        />
      </div>

      <div class="card-content">
        <h3>{{ projet.titre_projet | slice:0:20 }}...</h3>

        <p class="site-description">
          {{ projet.description_projet | slice:0:100 }}...
        </p>

        <div class="card-footer text-center">
          <a (click)="goToDetailsProjet(projet)" style="cursor:pointer">
            Lire plus →
          </a>
        </div>
      </div>

    </div>
  </ng-template>

</div>


      
      <!-- Charger plus -->
      <div class="text-center mt-4" *ngIf="displayedProjects.length < projects.length">
        <button class="btn btn-outline-primary" (click)="loadMore()">
          <i class="fas fa-plus-circle"></i> Charger plus
        </button>
      </div>

    </div>
  </section>

</div>